
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade/received",
      function () {
        return require("private-next-pages/trade/received/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade/received"])
      });
    }
  